<template>
  <div>
    <el-form
      ref="form"
      label-width="100px"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-form-item label="版本号" prop="bizVersionNo">
        <el-input
          clearable
          v-model="formData.bizVersionNo"
          placeholder="请输入版本号"
        >
        </el-input>
      </el-form-item>

      <el-form-item label="发布说明" prop="publishDescription">
        <div>
          <quill-editor
            :disabled="disabled"
            v-model="formData.publishDescription"
            :options="editorOptions"
          />
        </div>
      </el-form-item>
    </el-form>
    <el-dialog
      append-to-body
      title="提示信息"
      :visible.sync="backDialogVisible"
      v-el-dialog-drag
      width="30%"
    >
      <span>是否要保存更改</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small"
          >取消</el-button
        >
        <el-button @click="close()" size="small">不保存</el-button>
        <el-button type="primary" size="small" @click="save()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
export default {
  props: {
    disabled: Boolean,
    bizVersionCode: String,
  },
  components: {
    quillEditor,
  },
  data() {
    return {
      editorOptions: {
        modules: {
          toolbar: [
            'bold',
            'italic',
            'underline',
            'strike',
            { list: 'ordered' },
            { list: 'bullet' },
            { script: 'sub' },
            { script: 'super' },
            { color: [] },
            { background: [] },

            { size: ['small', false, 'large', 'huge'] },
          ],
        },
      },
      backDialogVisible: false,
      formData: { bizVersionStatus: 'N' },
      // pickerOptions:{
      //   disabledDate(time){
      //     return time.getTime()<Date.now()-8.64e7;
      //   }
      // },

      rules: {
        bizVersionNo: [
          { required: true, message: '请输入版本号', trigger: 'blur' },
        ],
        publishDescription: [
          { required: true, message: '请输入发布说明', trigger: 'blur' },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.bizVersionCode) return
      this.$api
        .systemVersionDetailApi({
          bizVersionCode: this.bizVersionCode,
        })
        .then((res) => {
          this.formData = res.body
          //this.statusVisible = res.body.bizVersionStatus === 'N'
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])

      let dscription
      if (this.formData.publishDescription) {
        dscription = this.formData.publishDescription
          .replace(/\n/g, '<br/>')
          .replace(/\s/g, '')
      }

      if (!result) {
        this.backDialogVisible = false
        return
      }
      this.formData.publishDescription = dscription

      let loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.$api
        .systemVersionSaveApi(this.formData)
        .then((res) => {
          loadingInstance.close()
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.close()
          this.$emit('reload')
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss">
.ql-editor {
  min-height: 200px;
}
</style>
